import { render } from "./OctagonOutline.vue?vue&type=template&id=5420a51f"
import script from "./OctagonOutline.vue?vue&type=script&lang=js"
export * from "./OctagonOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__